import { RootState } from '@reducers';

export const selectHealthQuotePaymentPage = (state: RootState) => state.healthQuotePaymentPageReducer;
